// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"351":"22403ad0bb041a029fd6","678":"d3a84825edb508147ad3","731":"4de98a8d60785e0e5b2a","843":"a75101acca522f1da784","883":"b6c5daa396bfce1cc6b1"}[chunkId] + ".js";
};